import React from "react";

// Admin Imports
import NFTMarketplace from "views/admin/marketplace";

// Auth Imports
import SignIn from "views/auth/SignIn";

// Icon Imports
import {
  MdPerson,
  MdLock,
  MdEvent,
  MdNotifications,
  MdContacts,
  MdCategory,
  MdStore,
  MdShoppingBag,
  Dashboard,
  MdAdminPanelSettings,
} from "react-icons/md";
import { VscOrganization } from "react-icons/vsc";
import { GoOrganization } from "react-icons/go";
import OrganizationEvents from "views/admin/organization";
import { BiCategory, BiSolidReport } from "react-icons/bi";
import { MdPayment  } from "react-icons/md";
import EventAndCarTypes from "views/admin/events";
import Explore from "views/admin/explore";
import BoostPricing from "views/admin/boostPricing";
import { HiOutlineCurrencyDollar } from "react-icons/hi";
import Reports from "views/admin/reports";
import Contacts from "views/admin/contacts";
import Notification from './views/admin/notification/Notification';
import ProductCategories from "views/admin/productCategories";
import Vendor from "views/admin/vendor";
import VendorWrapper from "views/admin/vendorWrapper";
import DashIcon from "components/icons/DashIcon";
import DashboardComponent from "views/admin/dashboard";
import TicketRevenue from "views/admin/ticketRevenue";
import { HiCurrencyDollar } from "react-icons/hi";
import { MdReceiptLong } from "react-icons/md";
import Gamification from "views/admin/gamification";



const VendorComingSoon = () => <div className="flex items-center justify-center h-full text-2xl font-bold text-gray-500">Coming Soon</div>;

const routes = [
  {
    name: "Sign In",
    layout: "/auth",
    path: "sign-in",
    icon: <MdLock className="h-6 w-6" />,
    component: <SignIn />,
  },
  // {
  //   name: "Dashboard",
  //   layout: "/",
  //   path: "dashboard",
  //   icon: <MdHome className="h-6 w-6" />,
  //   component: <MainDashboard />,
  // },
  {
    name: "Dashboard",
    layout: "/",
    path: "dashboard",
    icon: <DashIcon className="h-6 w-6" />,
    component: <DashboardComponent />,
  },
  {
    name: "Users",
    layout: "/",
    path: "users",
    icon: <MdPerson className="h-6 w-6" />,
    component: <NFTMarketplace />,
    secondary: true,
  },
  // {
  //   name: "Accounts",
  //   layout: "/",
  //   path: "accounts",
  //   icon: <OrganizationRequest className="h-6 w-6" />,
  //   component: <Accounts />,
  // },
  // {
  //   name: "Organization Accounts",
  //   layout: "/",
  //   icon: <VscOrganization className="h-6 w-6" />,
  //   path: "accounts",
  //   component: <Accounts />,
  // },
  {
    name: "Organization Requests",
    layout: "/",
    icon: <GoOrganization className="h-6 w-6" />,
    path: "organization-event",
    component: <OrganizationEvents />,
  },
  {
    name: "Explore",
    layout: "/",
    icon: <MdEvent className="h-6 w-6" />,
    path: "explore",
    component: <Explore />,
  },
  {
    name: "Boosts & Ticket Pricing",
    layout: "/",
    icon: <HiCurrencyDollar className="h-6 w-6" />,
    path: "boost-pricing",
    component: <BoostPricing />,
  },
  {
    name: "Event & Car Types",
    layout: "/",
    icon: <BiCategory className="h-6 w-6" />,
    path: "event-car-types",
    component: <EventAndCarTypes />,
  },
  {
    name: "Reports",
    layout: "/",
    icon: <BiSolidReport className="h-5 w-5" />,
    path: "reports",
    component: <Reports />,
  },
  {
    name: "Notification",
    layout: "/",
    path: "notification",
    icon: <MdNotifications className="h-6 w-6" />,
    component: <Notification />,
  },
  {
    name: "Vendor",
    layout: "/",
    icon: <MdStore className="h-6 w-6" />,
    path: "vendor",
    component: <VendorWrapper />,
  },
  {
    name: "Contacts",
    layout: "/",
    icon: <MdContacts className="h-5 w-5" />,
    path: "contacts",
    component: <Contacts />,
  },
  {
    name: "Ticket Transactions",
    layout: "/",
    icon: <MdReceiptLong  className="h-5 w-5" />,
    path: "ticket-revenue",
    component: <TicketRevenue />,
  },
  {
    name: "Gamification",
    layout: "/",
    icon: <MdAdminPanelSettings className="h-6 w-6" />,
    path: "gamification",
    component: <Gamification />,
  },
  // {
  //   name: "Comments",
  //   layout: "/",
  //   path: "comments",
  //   icon: <FaComments className="h-6 w-6" />,
  //   component: <Comments />,
  // },
  // {
  //   name: "Organization Request",
  //   layout: "/",
  //   path: "organization-request",
  //   icon: <VscOrganization className="h-6 w-6" />,
  //   component: <OrganizationRequest />,
  // },
];
export default routes;
